/* eslint-disable react/prop-types */
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import separate from "utils/separate";
import fixTableCellWidth from "../../utils/fixTableCellWidth";
import ghollakProfitCalculationStatus from "enums/ghollakProfitCalculationStatus";
import SoftBadge from 'components/SoftBadge';
import TableHeadItems from "./TableHeadItems";
import useModal from "hooks/useModal";
import ProfitDetailModal from "layouts/ghollakMinBalance/ProfitDetailModal";
import GhollakProfitProcessModal from "layouts/ghollakMinBalance/GhollakProfitProcessModal";
import SoftButton from "components/SoftButton";
import queryString from "utils/queryString";
import { toast } from "react-toastify";
import { getGhollakProfitCalculationsExport } from "services/ghollak.routes";
import { useState } from "react";
import Loading from "components/Loading";

function Row(props) {
    const { row, openProfitDetailModal, openProfitProcessModal } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.min_balance.ghollak_name}
                    style={fixTableCellWidth("150px")}>{row.min_balance.ghollak_name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.min_balance.investment_opportunity_name}
                    style={fixTableCellWidth("150px")}>{row.min_balance.investment_opportunity_name}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.base_amount))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.base_amount))}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.gross_profit_amount))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.gross_profit_amount))}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.user_profit_amount))}
                    style={fixTableCellWidth("140px")}>{separate(Number(row.user_profit_amount))}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.platform_fee_amount))}
                    style={fixTableCellWidth("120px")}>{separate(Number(row.platform_fee_amount))}</TableCell>
                <TableCell className="tablecell" align="left" title={ghollakProfitCalculationStatus(row.status)}
                    style={fixTableCellWidth("140px")}>{ghollakProfitCalculationStatus(row.status)}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("100px")}>
                    <SoftBadge variant="contained"
                        badgeContent="اعمال سود"
                        onClick={() => openProfitProcessModal(row.min_balance_id)}
                        style={{ cursor: "pointer" }}
                        color="info" size="xs" />
                    <SoftBadge variant="contained"
                        badgeContent="جزئیات"
                        onClick={() => openProfitDetailModal(row)}
                        style={{ cursor: "pointer" }}
                        color="secondary" size="xs" />
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function ProfitCalculationTable({ data, onClearFilterClick, filterInfo, handleFilterChange, onFilterClick }) {
    const [modals, updateModal, closeInsideModal] = useModal({
        profitProcess: { state: false },
        profitDetail: { state: false },
    });
    const closeProfitProcessModal = () => closeInsideModal("profitProcess");
    const closeProfitDetailModal = () => closeInsideModal("profitDetail");
    const [loading, setLoading] = useState(false)

    const openProfitDetailModal = (item) => {
        updateModal("profitDetail", { state: true, item })
    }

    const openProfitProcessModal = (minBalanceId) => {
        updateModal('profitProcess', { state: true, minBalanceIds: [minBalanceId] })
    }
    const exportToExcel = () => {
        const query = {
            ghollak_id: filterInfo.ghollak_id || null,
            investment_opportunity_id: filterInfo.investment_opportunity_id || null,
        };

        setLoading(true);
        getGhollakProfitCalculationsExport(queryString(query), (isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                window.open(data.link, '_blank');
            }
        })
    }
    return (
        <TableContainer component={Paper}>
            <Table>
                <Loading loading={loading} />
                <TableHead>
                    <TableHeadItems filterInfo={filterInfo} handleFilterChange={handleFilterChange} onClearFilterClick={onClearFilterClick} onFilterClick={onFilterClick} />
                    <SoftButton variant="gradient" onClick={exportToExcel} color="success" size="small">
                        دانلود خروجی اکسل
                    </SoftButton>
                    <TableRow>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>قلک</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("140px")}>فرصت</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>مبلغ معیار</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>سود ناخالص</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("130px")}>سود کاربر</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("120px")}>سهم پلتفرم</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>وضعیت</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("100px")}>عملیات</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody style={{ display: "block" }}>
                    {data.map((row) => (
                        <Row key={row.id} row={row} openProfitDetailModal={openProfitDetailModal} openProfitProcessModal={openProfitProcessModal} />
                    ))}
                </TableBody>
            </Table>
            {modals.profitProcess.state && <GhollakProfitProcessModal modalInfo={modals.profitProcess} closeModal={closeProfitProcessModal} />}
            {modals.profitDetail.state && <ProfitDetailModal modalInfo={modals.profitDetail} closeModal={closeProfitDetailModal} />}
        </TableContainer>
    );
}
